import { Box } from '@mantine/core';
import Head from 'next/head';
import { ReactNode } from 'react';

interface UnauthenticatedLayoutProps {
    title: string;
    children: ReactNode;
}

// Use this layout for pages that don't need authentication or any of our nav / other normal layout features
export default function UnauthenticatedLayout({ title, children }: UnauthenticatedLayoutProps) {
    const browserTitle = `dvmGateway - ${title}`;

    return (
        <>
            <Head>
                <title>{browserTitle}</title>
                <meta property="og:title" content={browserTitle} key="title" />

                {/* Use dvmReach favicon */}
                <link rel="icon" href="/favicon-reach.ico" />
            </Head>

            {/* Centered container with max-width and padding */}
            <main>
                <Box maw="700px" mx="auto" py="xl" px="md">
                    {children}
                </Box>
            </main>
        </>
    );
}
